import React from "react";
import { useAuth } from "../contexts/AuthContext";
import LeftNavBar from "../components/leftnavbar/LeftNavBar";
import { Toolbar, Box, Stack, Grid2 } from "@mui/material";
import { Outlet } from "react-router-dom";
import Tncbanner from "../components/tncbanner/Tncbanner";
import Expiredbanner from "../components/expiredbanner/Expiredbanner";
import Trialbanner from "../components/trialbanner/Trialbanner";

const Dashboard = () => {
    const { user } = useAuth()
    return (
        <>
        <Toolbar />
        <Box sx={{ display: 'flex', backgroundColor: 'background.default', minHeight: '100vh' }}>
            <LeftNavBar />
            <Stack sx={{ flexGrow: 1, maxWidth: '100vw', backgroundColor: 'background.default' }}>
                <Box sx={{ p: { xs: 2, sm: 3, md: 4 }, backgroundColor: 'background.default' }}>
                    <Outlet />
                </Box>
                <Trialbanner/>
                <Expiredbanner/>
                <Tncbanner/>
            </Stack>
        </Box>
        </>
    );
};

export default Dashboard;